import React from 'react';
import { Tag } from '@lux/text';

type AccessibleHeaderElementProps = React.HTMLAttributes<HTMLHeadingElement> & { tag: Tag };

export const AccessibleHeaderElement = ({
    children,
    className,
    tag,
    ...props
}: AccessibleHeaderElementProps) => {
    const Element = tag;

    return (
        <Element className={className} {...props}>
            {children}
        </Element>
    );
};
